module.exports = __webpack_public_path__ + "img/banner.f8ab3df3.png";